var _metadata, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 7 7",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "Made with Pixels to Svg https://codepen.io/shshaw/pen/XbxvNj")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#c51a00",
    d: "M1 0h2M4 0h2M0 1h1M3 1h1M6 1h1M0 2h1M6 2h1M0 3h1M6 3h1M1 4h1M5 4h1M2 5h1M4 5h1M3 6h1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#e4233d",
    d: "M1 1h2M4 1h2M1 2h5M1 3h5M2 4h3M3 5h1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.3c6ab1103b62f8247a53119af38a329a.svg";
export { ForwardRef as ReactComponent };